<div class="report-data" [style.flex-basis]="reportFlexBasis">
  <header *ngIf="activeReportConfig" class="page-header">
    <h1>
      {{activeReportConfig.name}}
      <span *ngIf="totals">({{totals.count | rf: 'number'}})</span>
      <span *ngIf="activeReportConfig.canUpdate" class="update-btn" (click)="updateReport()">
        <svg width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M448 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm644-420l-682 682q-37 37-90 37-52 0-91-37l-106-108q-38-36-38-90 0-53 38-91l681-681q39 98 114.5 173.5t173.5 114.5zm634-435q0 39-23 106-47 134-164.5 217.5t-258.5 83.5q-185 0-316.5-131.5t-131.5-316.5 131.5-316.5 316.5-131.5q58 0 121.5 16.5t107.5 46.5q16 11 16 28t-16 28l-293 169v224l193 107q5-3 79-48.5t135.5-81 70.5-35.5q15 0 23.5 10t8.5 25z"/></svg>
      </span>
    </h1>
    <div *ngFor="let headerAction of headerActions" class="btn-header-action" [title]="headerAction.name" (click)="launchHeaderAction(headerAction)">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v16H4zM4 10h16M4 16h16M10 4v16M16 4v16" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>
    </div>
    <div *ngIf="charts.length > 0" class="btn-chart" [title]="charts.length === 1 ? charts[0].name : 'Charts'" (click)="openChart()">
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 20V4M4 20h16M8 16v-5M12 16V8M16 16v-3M20 16V6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
    <div class="btn-print" (click)="print()"></div>
    <div *ngIf="canImport" class="btn-import" (click)="importRecords()">
      <input #importrecords class="invisible" type="file" name="importrecords"
        accept=".csv,.xlsx,.xls" (change)="onImportFileChange($event)" />
    </div>
    <div *ngIf="canAdd" class="btn-add" (click)="add()"></div>
  </header>
  <div class="table-container">
      <div class="table-controls">
        <div *ngIf="activeReportConfig?.datePath" class="date-range">
          <div class="icon"></div>
          <label for="date-range">Date Range</label>
          <app-filter-date-range class="w-100" (rangeChanged)="dateRangeUpdated($event)" [rangeConfig]="dateRangeSettings"></app-filter-date-range>
          <div *ngIf="template?.dateFilterLabel" class="date-filter-label">{{template.dateFilterLabel}}</div>
          <!-- {{activeReportConfig | json}} -->
        </div>

        <div class="spacer"></div>
        <div *ngIf="variantsControlVisible" class="variants-control" [class.open]="variantsOpen">
          <div class="variants-toggle" (click)="toggleVariantsMenu()" title="View variants">
            <span class="variant-name-label">{{activeVariantName}}</span>
            <span *ngIf="defaultVariantKey === activeVariantKey && activeVariantKey" class="default-star" title="Your default">★</span>
            <svg class="variants-caret" width="10" height="6" viewBox="0 0 10 6"><path d="M0 0l5 6 5-6z" fill="currentColor"/></svg>
          </div>
          <div *ngIf="variantsOpen" class="variants-menu">
            <ng-container *ngIf="defaultVariant">
              <div class="variants-section-label">Your default</div>
              <div class="variant-row"
                   [class.selected]="defaultVariant.key === activeVariantKey"
                   (click)="selectVariant(defaultVariant.key)">
                <span class="variant-row-name">{{defaultVariant.name}}</span>
                <span class="default-star" title="Your default">★</span>
              </div>
              <div class="variants-divider"></div>
            </ng-container>

            <div class="variants-section-label">System view</div>
            <div class="variant-row system" [class.selected]="!activeVariantKey" (click)="selectVariant('system')"
                 title="The report's built-in view. Cannot be modified.">
              <span class="variant-row-name">System Default</span>
              <span class="variant-row-meta">read-only</span>
            </div>

            <ng-container *ngIf="variants && variants.length > 0">
              <div class="variants-divider"></div>
              <div class="variants-section-label">Your views</div>
              <div *ngFor="let v of variants"
                   class="variant-row"
                   [class.selected]="v.key === activeVariantKey"
                   (click)="selectVariant(v.key)">
                <span class="variant-row-name">{{v.name}}</span>
                <span *ngIf="v.key === defaultVariantKey" class="default-star" title="Your default">★</span>
              </div>
            </ng-container>

            <div class="variants-divider"></div>

            <ng-container *ngIf="variantNameInputMode === null">
              <div *ngIf="canScheduleReports" class="variant-action" (click)="sendScheduledReport(); $event.stopPropagation()">Send Scheduled Report…</div>
              <div *ngIf="canScheduleReports" class="variants-divider"></div>
              <div class="variant-action" (click)="startSaveAsNew(); $event.stopPropagation()">Save current view as new variant…</div>
              <ng-container *ngIf="activeVariantKey">
                <div class="variant-action" (click)="updateActiveVariant(); $event.stopPropagation()">Save changes to "{{activeVariantName}}"</div>
                <div class="variant-action" (click)="startRenameActive(); $event.stopPropagation()">Rename</div>
                <div class="variant-action" *ngIf="activeVariantKey !== defaultVariantKey"
                     (click)="setActiveAsDefault(); $event.stopPropagation()">Set as your default</div>
                <div class="variant-action" *ngIf="activeVariantKey === defaultVariantKey"
                     (click)="clearDefaultVariant(); $event.stopPropagation()">Remove as your default</div>
                <div class="variant-action danger" (click)="deleteActiveVariant(); $event.stopPropagation()">Delete</div>
              </ng-container>
            </ng-container>

            <div *ngIf="variantNameInputMode !== null" class="variant-name-input-row" (click)="$event.stopPropagation()">
              <input id="variant-name-input" type="text" maxlength="60"
                     [placeholder]="variantNameInputMode === 'rename' ? 'New name' : 'Variant name'"
                     [(ngModel)]="variantNameInput"
                     (keydown.enter)="variantNameInputMode === 'rename' ? confirmRename() : confirmSaveAsNew()"
                     (keydown.escape)="cancelNameInput()" />
              <div class="variant-name-actions">
                <span class="variant-name-cancel" (click)="cancelNameInput()">Cancel</span>
                <span class="variant-name-confirm"
                      (click)="variantNameInputMode === 'rename' ? confirmRename() : confirmSaveAsNew()">
                  Save
                </span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="(availableFields && availableFields.length > 0) || hasColumnWidthOverrides()" class="fields dropdown-button" (click)="toggleFieldAdd()" [class.open]="fieldAddOpen">
          <!-- <div class="icon"></div> -->
          <svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"/></svg>
          <label for="fields">Fields</label>
          <div class="field-add-container dropdown-menu">
            <a *ngFor="let availableField of availableFields" (click)="addField(availableField)">{{availableField.name}}</a>
            <a *ngIf="hasColumnWidthOverrides()" class="reset-widths" (click)="resetAllColumnWidths($event)">Reset Column Widths</a>
          </div>
        </div>
        <div *ngIf="!totals || !totals.count || totals.count < 200000" class="search input">
          <div class="icon"></div>
          <label for="search">Search</label>
          <input type="text" id="search" placeholder="Search Report..." (keyup)="setSearch($event)">
        </div>

        <ng-container *ngIf="templateOptions && templateOptions.print">
          <div *ngFor="let printTemplate of templateOptions.print" class="print-options" (click)="printReport(printTemplate)">
            <div class="icon"></div>
            <label for="print">{{printTemplate.name}}</label>
          </div>
        </ng-container>

        <div *ngIf="activeReportConfig?.listBuilder" class="list-options" (click)="toggleListBuilder()" [class.active]="listBuilderActive">
          <div class="icon"></div>
          <label>Lists</label>
        </div>

        <div class="download" (click)="downloadReport()">
          <div class="icon"></div>
          <label for="download">Download</label>
        </div>
        <div class="refresh-report" (click)="refreshReport()">
          <div class="icon"></div>
        </div>
      </div>

      <!-- RANGE FILTER (right-click on a currency / number cell) -->
      <div *ngIf="rangeFilter" class="range-filter-wrapper" (mousedown)="cancelRangeFilter()">
        <div class="range-filter" (mousedown)="$event.stopPropagation()">
          <div class="range-filter-header">Filter {{rangeFilter.field.name}}</div>
          <div class="range-filter-modes">
            <label><input type="radio" name="rangeMode" value="equals" [(ngModel)]="rangeFilter.mode" /> Equals</label>
            <label><input type="radio" name="rangeMode" value="atLeast" [(ngModel)]="rangeFilter.mode" /> At least</label>
            <label><input type="radio" name="rangeMode" value="atMost" [(ngModel)]="rangeFilter.mode" /> At most</label>
            <label><input type="radio" name="rangeMode" value="between" [(ngModel)]="rangeFilter.mode" /> Between</label>
          </div>
          <div class="range-filter-inputs">
            <label *ngIf="rangeFilter.mode === 'equals'">Value <input type="text" [(ngModel)]="rangeFilter.value" (keydown.enter)="applyRangeFilter()" /></label>
            <label *ngIf="rangeFilter.mode === 'atLeast' || rangeFilter.mode === 'between'">Min <input type="text" [(ngModel)]="rangeFilter.min" (keydown.enter)="applyRangeFilter()" /></label>
            <label *ngIf="rangeFilter.mode === 'atMost' || rangeFilter.mode === 'between'">Max <input type="text" [(ngModel)]="rangeFilter.max" (keydown.enter)="applyRangeFilter()" /></label>
          </div>
          <div class="range-filter-footer">
            <div class="button" (click)="cancelRangeFilter()">Cancel</div>
            <div class="button confirm" (click)="applyRangeFilter()">Apply</div>
          </div>
        </div>
      </div>

      <div *ngIf="valueFilters && valueFilters.length > 0" class="value-filters">
        <div *ngFor="let valueFilter of valueFilters; let valueFilterIndex = index" class="value-filter">
          
          <ng-container *ngIf="!valueFilter.hidden && valueFilter.type !== 'link'">
            <div class="filter-name">
              {{valueFilter.name}}:
            </div>
            <div class="filter-value">
             {{valueFilter.displayValue || (valueFilter.value | rf:valueFilter.type)}}
            </div>
            <div class="filter-remove" (click)="removeValueFilterIndex(valueFilterIndex)">x</div>
          </ng-container>

          <ng-container *ngIf="valueFilter.type == 'link'">
            <div class="filter-link" (click)="filterLink(valueFilter.value)">
              {{valueFilter.name}}
            </div>
          </ng-container>

        </div>
      </div>

      <div *ngIf="listBuilderActive" class="list-actions">
        <div class="add-all-btn" (click)="addAllToList()">Add All</div>
        <div class="remove-all-btn" (click)="removeAllFromList()">Remove All</div>
      </div>

      <div class="flex-table">
          <div class="flex-body">
              <div class="header-row-wrapper">
                  <div class="flex-row header-row" [style.margin-left.px]="tsl*-1" [dragula]="'fields'" [(dragulaModel)]="activeFields">
                      <div class="field sortable" *ngFor="let activeField of activeFields" (click)="setSort(activeField)" [class.asc]="activeField.sort == 1" [class.desc]="activeField.sort == -1" [style.flex-basis.px]="activeField.width">
                        {{activeField.name}}
                        <img src="/assets/global/icon-angle-right.svg" />
                        <div class="close" (click)="removeField($event, activeField)"></div>
                        <div *ngIf="!isMobile && !childRouteOpen" class="resize-handle" title="Drag to resize — double-click to reset"
                             (mousedown)="startColumnResize($event, activeField)"
                             (dblclick)="resetColumnWidth($event, activeField)"
                             (click)="$event.stopPropagation()"></div>
                      </div>
                  </div>
              </div>
              <cdk-virtual-scroll-viewport style="position: absolute; top: 35px; bottom: 40px; left: 0; right: 0;" itemSize="37" (scrolledIndexChange)="reportScrolled($event)">
                  <!-- <div *ngIf="!(records)" class="loading">LOADING . . .</div> -->
                  <div *ngIf="loadMessage" class="no-results">{{loadMessage}}</div>
                  <div *ngIf="!loadMessage && records?.length === 0" class="no-results">No Results</div>

                  <ng-container *cdkVirtualFor="let record of records; trackBy: trackByIndex">
                    <div class="flex-row" [class.loading]="!record._id" [class.saving]="record.saving" [class.active]="record._id == activeDocumentId" [class.on-list]="listBuilderActive && isItemInList(record._id)" (click)="setDetailRecord(record)" [style.width.px]="tableWidth">
                      <div *ngFor="let activeField of activeFields" class="field" [class]="activeField.format || activeField.type" [class.editable]="activeField.canEdit" [style.flex-basis.px]="activeField.width" (contextmenu)="onRightClick(record, activeField)">
                        <ng-container *ngIf="record.editingField !== activeField.path">
                          <div *ngIf="activeField.type == 'string'; else unwrapped" class="single-line-text" [style.min-width.px]="activeField.width-30">
                            {{getValueByPath(record, activeField.path) | rf:(activeField.format || activeField.type)}}
                          </div>
                          <ng-template #unwrapped>
                            {{getValueByPath(record, activeField.path) | rf:(activeField.format || activeField.type)}}
                          </ng-template>
                        </ng-container>
                        <ng-container *ngIf="record.editingField === activeField.path">
                          <input type="text" id="active-quick-edit" [(ngModel)]="record[activeField.path]" (blur)="blurField($event, record, activeField)" (keydown)="updateField($event, record, activeField)" (click)="preventPropagation($event)" />
                        </ng-container>
                        <div *ngIf="activeField.canEdit && !activeDocumentId && record.editingField !== activeField.path && !record.saving" class="instant-edit-btn" (click)="fieldClick($event, record, activeField)">
                          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8477 1.87868C19.6761 0.707109 17.7766 0.707105 16.605 1.87868L2.44744 16.0363C2.02864 16.4551 1.74317 16.9885 1.62702 17.5692L1.03995 20.5046C0.760062 21.904 1.9939 23.1379 3.39334 22.858L6.32868 22.2709C6.90945 22.1548 7.44285 21.8693 7.86165 21.4505L22.0192 7.29289C23.1908 6.12132 23.1908 4.22183 22.0192 3.05025L20.8477 1.87868ZM18.0192 3.29289C18.4098 2.90237 19.0429 2.90237 19.4335 3.29289L20.605 4.46447C20.9956 4.85499 20.9956 5.48815 20.605 5.87868L17.9334 8.55027L15.3477 5.96448L18.0192 3.29289ZM13.9334 7.3787L3.86165 17.4505C3.72205 17.5901 3.6269 17.7679 3.58818 17.9615L3.00111 20.8968L5.93645 20.3097C6.13004 20.271 6.30784 20.1759 6.44744 20.0363L16.5192 9.96448L13.9334 7.3787Z" fill="currentColor"></path> </g></svg>
                        </div>
                      </div>
                      <div *ngIf="listBuilderActive && !isItemInList(record._id)" class="on-list-toggle" (click)="addToList($event, record._id)">&#x203a;</div>
                      <div *ngIf="listBuilderActive && isItemInList(record._id)" class="on-list-indicator" title="In active list">&#10003;</div>
                    </div>
                  </ng-container>
              </cdk-virtual-scroll-viewport>

              <div class="footer-row-wrapper">
                  <div class="flex-row footer-row" *ngIf="totals" [style.margin-left.px]="tsl*-1">
                      <!-- A column the report does not total has no entry in `totals`: leave its
                           footer cell blank rather than formatting the absence as 0. -->
                      <div *ngFor="let activeField of activeFields" class="field" [class]="activeField.format || activeField.type" [style.flex-basis.px]="activeField.width">
                        <ng-container *ngIf="getValueByPath(totals, activeField.path) != null">{{getValueByPath(totals, activeField.path) | rf: (activeField.format || activeField.type)}}</ng-container>
                      </div>
                  </div>
              </div>

          </div>
      </div>

  </div>
</div>
<div *ngIf="listBuilderActive" class="resize-handle" (mousedown)="startResize($event)"></div>
<app-list-builder *ngIf="listBuilderActive"></app-list-builder>
<router-outlet></router-outlet>
